import React, { useState } from 'react';
import { useTranslation } from '../../../i18n';
import { getCategoryLabel } from '../../../i18n/helpers';
import { getCategoriesForGame, CATEGORY_DEFINITIONS } from '../../../config/categories';
import { AppIcon } from '../icons';
import './CategoryResults.css';

interface CategoryResultsProps {
  gameType: string;
  categoryVotes: Record<string, number>;
  collapsible?: boolean;
  maxVisible?: number;
}

const CategoryResults: React.FC<CategoryResultsProps> = ({
  gameType,
  categoryVotes,
  collapsible = false,
  maxVisible = 5,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const categories = getCategoriesForGame(gameType);
  const hasVotes = Object.keys(categoryVotes).length > 0;
  const sortedVotes = Object.entries(categoryVotes).sort((a, b) => b[1] - a[1]);
  const hasMore = collapsible && sortedVotes.length > maxVisible;
  const visibleVotes = hasMore && !expanded ? sortedVotes.slice(0, maxVisible) : sortedVotes;

  return (
    <div className={`category-votes-display-host${collapsible ? ' category-votes-display-host--compact' : ''}`}>
      <h3><AppIcon name="howToVote" fontSize="small" /> {t('lobby.categories.votesHeader')}</h3>
      {!hasVotes ? (
        <p className="category-votes-waiting">{t('lobby.categories.waitingForVotes')}</p>
      ) : (
        <>
          <div className="category-votes-display-host-chips">
            {visibleVotes.map(([category, count]) => {
              const categoryInfo = CATEGORY_DEFINITIONS[category] ||
                categories.find((c) => c.value === category);
              return (
                <div key={category} className="category-vote-display-chip">
                  <span>{categoryInfo?.icon || '📦'}</span>
                  <span>{getCategoryLabel(category)}</span>
                  <span className="category-vote-display-chip-count">{count}</span>
                </div>
              );
            })}
          </div>
          {hasMore && (
            <button
              type="button"
              className="lobby-panel-expand-btn"
              onClick={() => setExpanded((v) => !v)}
            >
              {expanded ? t('common.showLess') : t('common.showAllCategories', { count: sortedVotes.length })}
            </button>
          )}
          <p className="category-votes-display-host-explanation">
            {t('lobby.categories.hostExplanation')}
          </p>
        </>
      )}
    </div>
  );
};

export default CategoryResults;
